import React from 'react';
import { connect } from 'react-redux';
import AuthButton from '../../components/Shared/AuthButton';
import tryMe from '../../helpers/tryMe';

// Higher-order component to wrap AuthButton with Redux state for loading
const AuthButtonWithLoading = (props) => {
  const { entities, entityName, ...buttonProps } = props;
  const item = entities[entityName];
  const loading = !!(tryMe(item).isFetching);

  return <AuthButton {...buttonProps} loading={loading} />;
};

function mapStateToProps(state) {
  return {
    entities: state.entities,
  };
}

export default connect(mapStateToProps)(AuthButtonWithLoading);
